{
  "Back": "Back",
  "Invoice": "Invoice",
  "Payment Due": "Payment Due",
  "Paid": "Paid",
  "Download PDF": "Download PDF",
  "Pay Invoice": "Pay Invoice",
  "Invoice Date": "Invoice Date",
  "Due Date": "Due Date",
  "Auto-Pay On": "Auto-Pay On",
  "Auto-Pay Off": "Auto-Pay Off",
  "Invoice Total": "Invoice Total",
  "Balance due": "Balance due",
  "Bill To": "Bill To",
  "Account Number": "Account Number",
  "Account Balance": "Account Balance",
  "Bill From": "Bill From",
  "Check payment instructions": "Check payment instructions",
  "If paying via check": "If paying via check, make it out to {{recipient}}, include your account number ({{accountNumber}}) and location ID ({{locationId}}) in the ‘memo’ section, and include a copy of this invoice with your check:",
  "USPS": "If sending via standard USPS, send to Industrious Office, P.O. Box 780441, Philadelphia PA 19178-0441.",
  "courier": "If sending via overnight or courier, send to Wells Fargo Lockbox Services, Industrious Office, Lockbox – 780441, MAC: Y1372-045, 401 Market Street, Philadelphia PA 19106.",
  "Payment is due on the invoice due date": "Payment is due on the invoice due date. A 10% late fee will be applied to any open balances that are more than 5 days past their due date. If you are already enrolled in ACH debit or credit card auto-pay, Industrious will charge your account on the invoice due date and no action is required.",
  "To the extent applicable": "To the extent applicable to the services being provided or license being granted to you and to the full extent that Industrious’ liabilities are limited, Industrious’ Terms of Use and Privacy Policy, located at ",
  "incorporated": "are incorporated by reference and govern and control our agreement as if you were a member and licensee of Industrious office space. Payment constitutes acceptance of all terms on this invoice by you.",
  "Please contact billing@industriousoffice.com with any questions regarding your invoice.": "Please contact billing@industriousoffice.com with any questions regarding your invoice.",
  "MAC": "MAC: Y1372-045, 401 Market Street, Philadelphia PA 19106.",
  "Applied Credit": "Applied Credit",
  "As of {{date}}, this invoice is not scheduled for auto-pay.": "As of {{date}}, this invoice is not scheduled for auto-pay.",
  "As of {{date}}, this invoice is scheduled for auto-pay.": "As of {{date}}, this invoice is scheduled for auto-pay.",
  "Item": "Item",
  "Description": "Description",
  "Service Period": "Service Period",
  "Unit Price": "Unit Price",
  "Quantity": "Quantity",
  "Amount": "Amount"
}
